import { tracked } from "@glimmer/tracking";

/**
 * Constants to represent commonly used, standard exception fields
 * @type {Object}
 */
const STANDARD_KEYS = {
  GENERIC: 'generic-exception',
};

export const VALIDATION_ERROR = {
  STANDARD_KEYS,
};

/**
 * Class used to encapsulate api validation errors
 */
export default class ValidationError extends Error {
  @tracked errors;

  /**
   * Provides options to easily construct a ValidationError with one or many errors
   *
   * @param {Object|string|undefined} errors
   */
  constructor(errors = undefined) {
    super();

    if (!!errors && errors.constructor === Object) { // Check for literal Object
      this.errors = errors;
    } else if (typeof errors === 'string') {
      this.errors = {
        [VALIDATION_ERROR.STANDARD_KEYS.GENERIC]: errors,
      };
    } else if (errors === undefined) {
      this.errors = { };
    } else {
      throw new Error('Invalid parameters');
    }
  }
}
